import React from 'react';
import bg from '../../assets/images/yzqf/sfbg.jpg';

function studyRoom({ setShow }) {
  return (
    <div className="common-page">
      <img src={bg} alt="" />
      <div
        className="hot"
        onClick={() => {
          setShow('glp');
        }}></div>

      <div
        className="back"
        onClick={() => {
          setShow('');
        }}></div>
    </div>
  );
}

export default studyRoom;
